import { AppLayout, PageHeader } from '@components'
import type { NextPage } from 'next'

const ManagedFund: NextPage = () => {
  return (
    <AppLayout>
      <div className="m-10 mx-auto flex flex-col items-center">
        <PageHeader title={'Scan This Code on Your Phone to Open WeChat'} />
        <img src="/images/social/wechat-qr.png" />
        <span className="m-5">
          or{' '}
          <a className="text-link" href="weixin://dl/chat?market_x">
            Click Here
          </a>
        </span>
      </div>
    </AppLayout>
  )
}

export default ManagedFund
